// @mui
import { LoadingButton } from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { translateKey } from 'src/locales/translate';


// ----------------------------------------------------------------------

interface AccountBusinessConfirmationModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export default function AccountBusinessConfirmationModal({
  isOpen,
  onCancel,
  onConfirm,
  isLoading,
}: AccountBusinessConfirmationModalProps) {
  return (
    <Dialog open={isOpen} onClose={onCancel}>
      <DialogTitle>{translateKey("hardcoded.potwierdz_dane_twojej_placowki")}</DialogTitle>

      <DialogContent sx={{ maxWidth: '400px' }}>
        <DialogContentText id="alert-dialog-description">{translateKey("hardcoded.upewnij_sie_ze_podane_informacje_sa_poprawne_zostana")}</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={onCancel}>
          Zweryfikuj dane
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          onClick={onConfirm}
          disabled={isLoading}
          loading={isLoading}
        >
          <span>Potwierdzam</span>
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
